module.exports = __webpack_public_path__ + "static/media/ccus_guide_2.3303f42f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ccus_guide_2.svg
// module id = 13481
// module chunks = 0